export var useEmptyAllergiesCopy = function (noKnownAllergies) {
    return noKnownAllergies ? 'No allergies reported' : 'No allergy data';
};
